import registry from '../../i18n/locales.generated.json' with { type: 'json' };

export const DOCUMENTATION_ORIGIN = 'https://docs.paperzilla.ai';

export function documentationHref(locale: string): string {
    const entry = registry.locales.find(({ tag, stage }) => tag === locale && stage === 'live');
    return entry?.pathPrefix
        ? `${DOCUMENTATION_ORIGIN}/${entry.pathPrefix}/what-is-paperzilla`
        : DOCUMENTATION_ORIGIN;
}
